export const ICON_ACCOUNT_SETTINGS = 'icon-account-settings';
export const ICON_ADD = 'icon-add';
export const ICON_ARROW_LEFT_1 = 'icon-arrow-left-1';
export const ICON_ARROW_LEFT_2 = 'icon-arrow-left-2';
export const ICON_ARROW_LEFT_3 = 'icon-arrow-left-3';
export const ICON_ARROW_RIGHT_1 = 'icon-arrow-right-1';
export const ICON_ARROW_RIGHT_2 = 'icon-arrow-right-2';
export const ICON_ARROW_RIGHT_3 = 'icon-arrow-right-3';
export const ICON_BIN_1 = 'icon-bin-1';
export const ICON_BIN_2 = 'icon-bin-2';
export const ICON_BUY_NOW = 'icon-buy-now';
export const ICON_CALENDAR_1 = 'icon-calendar-1';
export const ICON_CALENDAR_2 = 'icon-calendar-2';
export const ICON_CART_ITEM_ADD = 'icon-cart-item-add';
export const ICON_CART_ITEM_REMOVE = 'icon-cart-item-remove';
export const ICON_CART = 'icon-cart';
export const ICON_CHART_PIE = 'icon-chart-pie';
export const ICON_CHART = 'icon-chart';
export const ICON_CHECK = 'icon-check';
export const ICON_CHECKOUT = 'icon-checkout';
export const ICON_CLIP = 'icon-clip';
export const ICON_CLOSE = 'icon-close';
export const ICON_COG = 'icon-cog';
export const ICON_CONTENT = 'icon-content';
export const ICON_CURVE_UP = 'icon-curve-up';
export const ICON_DASHBOARD = 'icon-dashboard';
export const ICON_DIRECTION_BOTTOM_1 = 'icon-direction-bottom-1';
export const ICON_DIRECTION_BOTTOM_2 = 'icon-direction-bottom-2';
export const ICON_DIRECTION_BOTTOM_3 = 'icon-direction-bottom-3';
export const ICON_DIRECTION_BOTTOM_4 = 'icon-direction-bottom-4';
export const ICON_DIRECTION_LEFT_1 = 'icon-direction-left-1';
export const ICON_DIRECTION_LEFT_2 = 'icon-direction-left-2';
export const ICON_DIRECTION_LEFT_3 = 'icon-direction-left-3';
export const ICON_DIRECTION_LEFT_4 = 'icon-direction-left-4';
export const ICON_DIRECTION_RIGHT_1 = 'icon-direction-right-1';
export const ICON_DIRECTION_RIGHT_2 = 'icon-direction-right-2';
export const ICON_DIRECTION_RIGHT_3 = 'icon-direction-right-3';
export const ICON_DIRECTION_RIGHT_4 = 'icon-direction-right-4';
export const ICON_DIRECTION_TOP_1 = 'icon-direction-top-1';
export const ICON_DIRECTION_TOP_2 = 'icon-direction-top-2';
export const ICON_DIRECTION_TOP_3 = 'icon-direction-top-3';
export const ICON_DIRECTION_TOP_4 = 'icon-direction-top-4';
export const ICON_DOWNLOAD_INVOICE_MINI = 'icon-download-invoice-mini';
export const ICON_DOWNLOAD_ZIP_MINI = 'icon-download-zip-mini';
export const ICON_DOWNLOAD = 'icon-download';
export const ICON_EDIT = 'icon-edit';
export const ICON_ERROR_CIRCLE = 'icon-error-circle';
export const ICON_EXTERNAL_LINK = 'icon-external-link';
export const ICON_EYE = 'icon-eye';
export const ICON_FACE_FROWN = 'icon-face-frown';
export const ICON_FACE_SMILE = 'icon-face-smile';
export const ICON_FILE_INVOICE_MINI = 'icon-file-invoice-mini';
export const ICON_FILE_INVOICE = 'icon-file-invoice';
export const ICON_FILE_JSON_MINI = 'icon-file-json-mini';
export const ICON_FILE_JSON = 'icon-file-json';
export const ICON_FILE_XML_MINI = 'icon-file-xml-mini';
export const ICON_FILE_XML = 'icon-file-xml';
export const ICON_FILE_ZIP_MINI = 'icon-file-zip-mini';
export const ICON_FILE_ZIP = 'icon-file-zip';
export const ICON_INFO_CIRCLE_NEGATIVE = 'icon-info-circle-negative';
export const ICON_INFO_CIRCLE = 'icon-info-circle';
export const ICON_INFO = 'icon-info';
export const ICON_INVOICE = 'icon-invoice';
export const ICON_LABEL_ADD = 'icon-label-add';
export const ICON_LABEL_REMOVE = 'icon-label-remove';
export const ICON_LABEL = 'icon-label';
export const ICON_LANGUAGE = 'icon-language';
export const ICON_LOCK = 'icon-lock';
export const ICON_LOGIN = 'icon-login';
export const ICON_LOGO_FULL = 'icon-logo-full';
export const ICON_LOGO_MIN = 'icon-logo-min';
export const ICON_LOGOUT = 'icon-logout';
export const ICON_MAIL = 'icon-mail';
export const ICON_MINUS_CIRCLE = 'icon-minus-circle';
export const ICON_MINUS_SQUARE = 'icon-minus-square';
export const ICON_MINUS = 'icon-minus';
export const ICON_MY_ORDERS = 'icon-my-orders';
export const ICON_NEWSPAPER = 'icon-newspaper';
export const ICON_ORDER_BOOK = 'icon-order-book';
export const ICON_PAGE_TOP = 'icon-page-top';
export const ICON_PERSONAL_DATA = 'icon-personal-data';
export const ICON_PLUS_CIRCLE = 'icon-plus-circle';
export const ICON_PLUS_SQUARE = 'icon-plus-square';
export const ICON_PLUS = 'icon-plus';
export const ICON_PURCHASED_CONTENT = 'icon-purchased-content';
export const ICON_QUESTION_MARK = 'icon-question-mark';
export const ICON_RELOAD = 'icon-reload';
export const ICON_REMOVE = 'icon-remove';
export const ICON_RESIZE = 'icon-resize';
export const ICON_SEARCH = 'icon-search';
export const ICON_SPEECH_SMILE = 'icon-speech-smile';
export const ICON_STAR_FILLED = 'icon-star-filled';
export const ICON_STAR = 'icon-star';
export const ICON_SUCCESS_CIRCLE = 'icon-success-circle';
export const ICON_TAG = 'icon-tag';
export const ICON_TRIANGLE_BOTTOM = 'icon-triangle-bottom';
export const ICON_TRIANGLE_LEFT = 'icon-triangle-left';
export const ICON_TRIANGLE_RIGHT = 'icon-triangle-right';
export const ICON_TRIANGLE_TOP = 'icon-triangle-top';
export const ICON_USER = 'icon-user';
export const ICON_WARNING_CIRCLE = 'icon-warning-circle';
export const ICON_WORD = 'icon-word';
export const ICON_ZOOM = 'icon-zoom';


// More conveniently named icon constants
export const ICON_ERROR = 'icon-error';
export const ICON_LEFT = 'icon-previous';
export const ICON_NEXT = 'icon-next';
export const ICON_PREVIOUS = 'icon-previous';
export const ICON_RIGHT = 'icon-next';
export const ICON_SUCCESS = 'icon-success';



export const ICONS = [
    ICON_ACCOUNT_SETTINGS,
    ICON_ADD,
    ICON_ARROW_LEFT_1,
    ICON_ARROW_LEFT_2,
    ICON_ARROW_LEFT_3,
    ICON_ARROW_RIGHT_1,
    ICON_ARROW_RIGHT_2,
    ICON_ARROW_RIGHT_3,
    ICON_BIN_1,
    ICON_BIN_2,
    ICON_BUY_NOW,
    ICON_CALENDAR_1,
    ICON_CALENDAR_2,
    ICON_CART_ITEM_ADD,
    ICON_CART_ITEM_REMOVE,
    ICON_CART,
    ICON_CHART_PIE,
    ICON_CHART,
    ICON_CHECK,
    ICON_CHECKOUT,
    ICON_CLIP,
    ICON_CLOSE,
    ICON_COG,
    ICON_CONTENT,
    ICON_CURVE_UP,
    ICON_DASHBOARD,
    ICON_DIRECTION_BOTTOM_1,
    ICON_DIRECTION_BOTTOM_2,
    ICON_DIRECTION_BOTTOM_3,
    ICON_DIRECTION_BOTTOM_4,
    ICON_DIRECTION_LEFT_1,
    ICON_DIRECTION_LEFT_2,
    ICON_DIRECTION_LEFT_3,
    ICON_DIRECTION_LEFT_4,
    ICON_DIRECTION_RIGHT_1,
    ICON_DIRECTION_RIGHT_2,
    ICON_DIRECTION_RIGHT_3,
    ICON_DIRECTION_RIGHT_4,
    ICON_DIRECTION_TOP_1,
    ICON_DIRECTION_TOP_2,
    ICON_DIRECTION_TOP_3,
    ICON_DIRECTION_TOP_4,
    ICON_DOWNLOAD_INVOICE_MINI,
    ICON_DOWNLOAD_ZIP_MINI,
    ICON_DOWNLOAD,
    ICON_EDIT,
    ICON_ERROR_CIRCLE,
    ICON_EXTERNAL_LINK,
    ICON_EYE,
    ICON_FACE_FROWN,
    ICON_FACE_SMILE,
    ICON_FILE_INVOICE_MINI,
    ICON_FILE_INVOICE,
    ICON_FILE_JSON_MINI,
    ICON_FILE_JSON,
    ICON_FILE_XML_MINI,
    ICON_FILE_XML,
    ICON_FILE_ZIP_MINI,
    ICON_FILE_ZIP,
    ICON_INFO_CIRCLE_NEGATIVE,
    ICON_INFO_CIRCLE,
    ICON_INFO,
    ICON_INVOICE,
    ICON_LABEL_ADD,
    ICON_LABEL_REMOVE,
    ICON_LABEL,
    ICON_LANGUAGE,
    ICON_LOCK,
    ICON_LOGIN,
    ICON_LOGO_FULL,
    ICON_LOGO_MIN,
    ICON_LOGOUT,
    ICON_MAIL,
    ICON_MINUS_CIRCLE,
    ICON_MINUS_SQUARE,
    ICON_MINUS,
    ICON_MY_ORDERS,
    ICON_NEWSPAPER,
    ICON_ORDER_BOOK,
    ICON_PAGE_TOP,
    ICON_PERSONAL_DATA,
    ICON_PLUS_CIRCLE,
    ICON_PLUS_SQUARE,
    ICON_PLUS,
    ICON_PURCHASED_CONTENT,
    ICON_QUESTION_MARK,
    ICON_RELOAD,
    ICON_REMOVE,
    ICON_RESIZE,
    ICON_SEARCH,
    ICON_SPEECH_SMILE,
    ICON_STAR_FILLED,
    ICON_STAR,
    ICON_SUCCESS_CIRCLE,
    ICON_TAG,
    ICON_TRIANGLE_BOTTOM,
    ICON_TRIANGLE_LEFT,
    ICON_TRIANGLE_RIGHT,
    ICON_TRIANGLE_TOP,
    ICON_USER,
    ICON_WARNING_CIRCLE,
    ICON_WORD,
    ICON_ZOOM,


    ICON_ERROR,
    ICON_LEFT,
    ICON_NEXT,
    ICON_PREVIOUS,
    ICON_RIGHT,
    ICON_SUCCESS
];
